import { api } from './client';
import type { AppSettings } from '@/types';

export const settingsApi = {
  get: () => api.get<AppSettings>('/api/settings'),
  health: () =>
    api.get<{
      status: string;
      version: string;
      uptimeSeconds: number;
      database: { provider: string; ok: boolean; detail?: string };
      queue: { provider: string; waiting: number; active: number };
    }>('/api/health'),
};
